// discordUtils.js

export async function sendMessageToDiscord(module, func, msg) {
    try {
        const now = new Date().toLocaleString('en-US', {
            timeZone: 'Asia/Jakarta',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false // This ensures 24-hour time format
          }).replace(',', '');

        const message =
`
date: ${now}
module: ${module}
func: ${func}
message: ${msg}
`;

        const webhookUrl = 'https://discord.com/api/webhooks/1138147711980425237/NrhyYNoXF7xtwof1GyNLQd19RlZHsdZUjDPE6u58ROkwsPeNAPLDeDwxuA-WYpdLV4W8';

        const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            content: ':blue_circle: FE```\n' + message + '\n```',
        }),
        });

        if (!response.ok) {
            // throw new Error('Failed to send message to Discord');
            console.log('Failed to send message to Discord');
        }

        return true;

    } catch (error) {
      console.error('Error sending message to Discord:', error);
      return false;
    }
  }
